export class GitlabPerson {
    name: string;
    username: string;
    email: string;

    constructor() {
    }
}
